var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.showQuantity && _vm.useLargeScale && _vm.canBeAddedToBasket
      ? _c(
          "div",
          {
            directives: [{ name: "tooltip", rawName: "v-tooltip" }],
            staticClass: "add-to-basket-lg-container d-none d-lg-block",
            class: { "no-pointer-events": _vm.isLoading },
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: _vm.$translate("Ceres::Template.singleItemAddToBasket"),
            },
            on: {
              click: function ($event) {
                return _vm.addToBasket()
              },
            },
          },
          [
            _c("icon", {
              staticClass: "fa-lg mobile-icon-right",
              attrs: { icon: "cart-plus", loading: _vm.isLoading },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.showQuantity && _vm.useLargeScale && !_vm.canBeAddedToBasket
      ? _c(
          "div",
          {
            directives: [{ name: "tooltip", rawName: "v-tooltip" }],
            staticClass: "add-to-basket-lg-container d-none d-lg-block",
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: _vm.$translate("Ceres::Template.itemShowItem"),
            },
            on: {
              click: function ($event) {
                return _vm.directToItem()
              },
            },
          },
          [
            _c("i", {
              staticClass: "fa fa-arrow-right fa-lg d-none d-sm-block",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showQuantity && !_vm.useLargeScale
      ? _c("div", { staticClass: "d-inline" }, [
          _c("div", { staticClass: "add-to-basket-container" }, [
            _c(
              "div",
              { staticClass: "quantity-input-container" },
              [
                _c("quantity-input", {
                  attrs: {
                    value: _vm.quantity,
                    timeout: 0,
                    min: _vm.minimumQuantity,
                    max: _vm.maximumQuantity,
                    interval: _vm.intervalQuantity,
                    "variation-id": _vm.variationId,
                    waiting:
                      _vm.isLoading ||
                      !_vm.isSalable ||
                      !_vm.allVariationsSelected,
                  },
                  on: {
                    "quantity-change": _vm.updateQuantity,
                    "out-of-stock": _vm.handleButtonState,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.allVariationsSelected || !_vm.isSalable
              ? _c(
                  "button",
                  {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    staticClass:
                      "btn btn-block btn-primary btn-appearance disabled",
                    class: _vm.buttonClasses,
                    style: _vm.paddingInlineStyles,
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: _vm.tooltipText,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate(
                            "modeherz::SingleItemPageClient.itemPageAddToBasketSoldOut"
                          )
                        ) +
                        "\n                "
                    ),
                  ]
                )
              : !_vm.buttonLockState
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-block btn-primary btn-appearance",
                    class: _vm.buttonClasses,
                    style: _vm.paddingInlineStyles,
                    attrs: { disabled: _vm.isLoading || !_vm.hasPrice },
                    on: {
                      click: function ($event) {
                        return _vm.addToBasket()
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          " d-flex justify-content-center align-items-center",
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.singleItemAddToBasket"
                              )
                            ) +
                            "\n                        "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "wkcustom-btn ml-3",
                            attrs: {
                              alt: _vm.$translate(
                                "Ceres::Template.singleItemAddToBasket"
                              ),
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "18px",
                                  height: "20px",
                                  viewBox: "0 0 25 27",
                                  version: "1.1",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "Page-1",
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "basket_white",
                                          transform:
                                            "translate(1.000000, 1.000000)",
                                          stroke: "#FFFFFF",
                                          "stroke-width": "1.5",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M3.66666667,0 L0,5 L0,22.5 C0,23.8807119 1.09441506,25 2.44444444,25 L19.5555556,25 C20.9055849,25 22,23.8807119 22,22.5 L22,5 L18.3333333,0 L3.66666667,0 Z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M0,5 L22,5" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M15.8888889,10 C15.8888889,12.7614237 13.7000588,15 11,15 C8.29994122,15 6.11111111,12.7614237 6.11111111,10",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _c(
                  "button",
                  {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    staticClass:
                      "btn btn-block btn-primary btn-appearance disabled",
                    class: _vm.buttonClasses,
                    style: _vm.paddingInlineStyles,
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: _vm._f("translate")(
                        "Ceres::Template.singleItemQuantityMax",
                        { max: _vm.maximumQuantity }
                      ),
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate(
                            "modeherz::SingleItemPageClient.itemPageAddToBasketSoldOut"
                          )
                        ) +
                        "\n                "
                    ),
                  ]
                ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.showQuantity && !_vm.useLargeScale
      ? _c(
          "div",
          { staticClass: "d-inline", class: { "d-lg-none": !_vm.isWishList } },
          [
            _c(
              "div",
              {
                staticClass: "btn-group",
                attrs: { role: "group", "aria-label": "Thumb Control" },
              },
              [
                _vm.canBeAddedToBasket
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-appearance mobile-width-button",
                        class: { "no-pointer-events": _vm.isLoading },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.addToBasket()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.singleItemAddToBasket"
                              )
                            ) +
                            "\n                    "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "wkcustom-btn float-right ml-2",
                            attrs: {
                              alt: _vm.$translate("Ceres::Template.basket"),
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "15px",
                                  height: "17px",
                                  viewBox: "0 0 25 27",
                                  version: "1.1",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "Page-1",
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "basket_white",
                                          transform:
                                            "translate(1.000000, 1.000000)",
                                          stroke: "#FFFFFF",
                                          "stroke-width": "1.5",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M3.66666667,0 L0,5 L0,22.5 C0,23.8807119 1.09441506,25 2.44444444,25 L19.5555556,25 C20.9055849,25 22,23.8807119 22,22.5 L22,5 L18.3333333,0 L3.66666667,0 Z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M0,5 L22,5" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M15.8888889,10 C15.8888889,12.7614237 13.7000588,15 11,15 C8.29994122,15 6.11111111,12.7614237 6.11111111,10",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.canBeAddedToBasket
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-appearance mobile-width-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.directToItem()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.itemShowItem")
                            ) +
                            "\n                    "
                        ),
                        _c("i", {
                          staticClass:
                            "fa fa-arrow-right fa-lg ml-sm-1 d-none d-sm-inline",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }